var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-container",class:[
    ("screen-container--" + _vm.direction),
    { 'screen-container--full-height': _vm.fullHeight, 'screen-container--no-header': _vm.noHeader } ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }